<template>
  <footer class="footer mt-auto py-3">
    <div class="container">
      <span class="text-muted">&copy; Jeisson Francois Rosas Céspedes</span>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'jfooter'
}
</script>
